import { Directive } from '@angular/core';

/**
 * Marker directives that make the `ftExpandableContent` projection-slot tags
 * (`<collapsed>`, `<primary>`, `<custom>`, `<secondary>`) KNOWN elements, so a
 * consumer module (e.g. AdvocacyGroupModule / audiences) can compile them under
 * `CUSTOM_ELEMENTS_SCHEMA` instead of the looser `NO_ERRORS_SCHEMA`. Bare
 * (non-hyphenated) custom tags are NOT tolerated by `CUSTOM_ELEMENTS_SCHEMA`;
 * declaring an element-name-selector directive for them is what flips the
 * AdvocacyGroupModule off the `NO_ERRORS_SCHEMA` crutch (HANDOFF §6.1).
 *
 * They carry no behaviour — `FtExpandableContentComponent` projects each tag
 * through `<ng-content select="...">`, keeping the wrapper element in the DOM.
 * `<secondary>` gets its own directive so the host can `@ContentChild` it and
 * render `.ft-secondary-area` only when a secondary slot is supplied (v1
 * appended that area only when `<panel>` children existed).
 *
 * Element-name selectors without a dash are valid for *declared* directives.
 * Blast radius is nil: these tags appear only inside `<ft-expandable-content>`
 * (today, just audiences).
 */
@Directive({
    selector: 'collapsed, primary, custom',
    standalone: false
})
export class FtExpandableSlotDirective {}

@Directive({
    selector: 'secondary',
    standalone: false
})
export class FtExpandableSecondaryDirective {}
